import React from 'react';
import PropTypes from 'prop-types';
import { ContentBlock, FooterTitle, RawHtml } from '../../../common/index.jsx';
import useTranslateMethod from '../../../../utils/helpers/useTranslateMethod.jsx';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { useTranslation } from 'react-i18next';
import {
  DATETIME_FORMAT_DATETIME,
  formattedFullName,
} from '../../../../utils/helpers/CommonHelper.jsx';
import dayjs from 'dayjs';
import { EditOutlined } from '@ant-design/icons';
import HtmlContentWithAntdImages from '../../../common/Image/HtmlContentWithAntdImages.jsx';
import { Flex } from 'antd';
import '../../../antd/form/FormTextEditor/editorContent.css';

const ArticleContent = ({
  articlePage,
  isEnglishVersion,
  showEditIcon,
  redirectToPage,
}) => {
  const { creator, responsible } = articlePage;
  const { t , i18n} = useTranslation();
  const alternateLanguageCode = isEnglishVersion ? 'sk' : 'en';
  const alternateLanguageSlug = isEnglishVersion
    ? articlePage.slug_sk
    : articlePage.slug_en;
  const alternateLanguageBaseRoute =
    alternateLanguageCode === 'en' ? routes.articleEnglish : routes.article;

  const alternateLanguageHref = alternateLanguageSlug
    ? `${alternateLanguageBaseRoute}/${alternateLanguageSlug}`
    : null;
  const alternateLanguageLabel = isEnglishVersion
    ? t('SK')
    : t('EN');


  const formattedCreator = (creator && formattedFullName(creator)) || '';
  const formattedResponsible =
    (responsible && formattedFullName(responsible)) || '';
  const formattedDate = dayjs(
    (articlePage && articlePage.updated_at) ||
      (articlePage && articlePage.created_at) ||
      new Date(),
  ).format(DATETIME_FORMAT_DATETIME);

  return (
    <div className="custom-page-dynamic-container add-icons-to-file-anchors">
      <ContentBlock
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        contentVisible
        title={useTranslateMethod(articlePage.title_sk, articlePage.title_en)}
        actions={
          showEditIcon
            ? [
                {
                  title: t('Upraviť'),
                  onClick: () =>
                    redirectToPage(
                      `${routes.cmsArticleEdit}/${articlePage.id}`,
                    ),
                  icon: <EditOutlined />,
                },
              ]
            : []
        }
      >
        <div className={'tinymce-content'}>
          <HtmlContentWithAntdImages
            content={useTranslateMethod(
              articlePage.content_sk,
              articlePage.content_en,
            )}
          />
        </div>
        <FooterTitle>
          <Flex style={{ width: '100%' }} justify={'space-between'}>
            <p style={{ flex: 1 }}>
              <strong>{t('Autor')}:</strong> {formattedCreator}
            </p>
            {/*<p style={{ flex: 1 }}>*/}
            {/*  {responsible && (*/}
            {/*    <>*/}
            {/*      <strong>{t('Zodpovedná osoba')}:</strong> {formattedResponsible}*/}
            {/*    </>*/}
            {/*  )}*/}
            {/*</p>*/}
            <p style={{ flex: 1 }} align={'right'}>
              <strong>{t('Posledná zmena')}:</strong> {formattedDate}
            </p>
          </Flex>
        </FooterTitle>
        {alternateLanguageHref && (
          <p style={{ marginTop: 2, textAlign: 'right' }}>
            <a
              href={alternateLanguageHref}
              onClick={async (event) => {
                event.preventDefault();
                await i18n.changeLanguage(alternateLanguageCode);
                redirectToPage(alternateLanguageHref);
              }}
            >
              {alternateLanguageLabel}
            </a>
          </p>
        )}
      </ContentBlock>
    </div>
  );
};

ArticleContent.propTypes = {
  articlePage: PropTypes.object,
  isEnglishVersion: PropTypes.bool,
  showEditIcon: PropTypes.bool,
  redirectToPage: PropTypes.func,
  openLightBoxImg: PropTypes.func,
};

export default ArticleContent;
